import React from "react";
import Card from "../UI/Card";
import TableScrollable from "../UI/Table/TableScrollable";
import TableHeader from "../UI/Table/TableHeader";
import TableCell from "../UI/Table/TableCell";
import PageLoader from "../UI/PageLoader";
import { hoverLink } from "../../utils/hoverLink";
import { Link } from "react-router-dom";
import EmptyTable from "../UI/EmptyTable";
import CardHeader from "../UI/CardHeader";

export default function CoursesTable({ courses, isAdmin }) {
  return (
    <Card classNames="mb-4 min-h-[425px]">
      <CardHeader title="Courses" to={isAdmin ? "/courses" : false} />

      {courses?.length > 0 ? (
        <TableScrollable height={300}>
          <thead>
            <tr>
              <TableHeader classNames="w-1/3">COURSE</TableHeader>
              <TableHeader classNames="w-1/3 text-center">STUDENTS</TableHeader>
              <TableHeader classNames="w-1/3 text-center">
                NEEDING-FOLLOW-UP
              </TableHeader>
            </tr>
          </thead>
          <tbody className="h-[300px]">
            {courses.map((course) => (
              <tr key={course.id}>
                <TableCell classNames="w-1/3">
                  {isAdmin ? (
                    <Link
                      className={hoverLink}
                      to={`/courses/${course?.id}/overview`}
                    >
                      {course.name}
                    </Link>
                  ) : (
                    course.name
                  )}
                </TableCell>
                <TableCell classNames="w-1/3 text-center">
                  {course.students_count}
                </TableCell>
                <TableCell classNames="w-1/3 text-center">-</TableCell>
              </tr>
            ))}
          </tbody>
        </TableScrollable>
      ) : courses ? (
        <EmptyTable message="No courses available." />
      ) : (
        <PageLoader />
      )}
    </Card>
  );
}
